import { createFileRoute, redirect } from '@tanstack/react-router'

// /voices is folded into /templates (filter=voices). Anyone hitting
// the old URL — bookmarks, sidebar links from older builds — is
// transparently bounced. Removing the route entry would 404 instead
// of redirecting, which is jarring for users who pinned the link.
export const Route = createFileRoute('/_authenticated/voices')({
  beforeLoad: () => {
    throw redirect({ to: '/templates' })
  },
})
